(function($) {
    const contactForm               = '.contact-form';
    const container                 = `${contactForm}__container`;
    const loader                    = `${contactForm}__loader`;
    const error                     = `${contactForm}__error`;
    
    function openLoader( $loader ) {
        $loader.css('display', 'flex');
        setTimeout(function() {
            $loader.addClass( 'open' );
        }, 5);
    }
    
    function closeLoader( $loader ) {
        $loader.removeClass( 'open' );
        setTimeout(function() {
            $loader.css('display', 'none');
        }, 310);
    }
    
    function submitForm(e) {
        e.preventDefault();
        const $form             = $( this );
        $form.find(error).remove();
        
        const $container    = $form.find( container );
        const $loader           = $form.find(loader);
        openLoader( $loader );
        
        const data  = {
            first_name: $form.find('input[name="first_name"]').val(),
            last_name: $form.find('input[name="last_name"]').val(),
            email: $form.find('input[name="email"]').val(),
            phone: $form.find('input[name="phone"]').val(),
            more_information: $form.find('select[name="more_information"]').val(),
            comments: $form.find('textarea[name="comments"]').val(),
            turnstileToken: $form.find('input[name="cf-turnstile-response"]').val(),
        };
        
        var message     = 'Thank you! We will be in touch shortly.';
        var success     = true;
        $.ajax({
            type: 'POST',
            url: '/wp-json/cd-contact/v1/submit',
            dataType: 'json',
            data: data,
            success: function(data) {
                if( !data.success ) {
                    message = data.error;
                    success = false;
                }
            },
            error: function(err) {
                message = 'There was a problem with your submission. Please try again later.';
                success = false;
            },
            complete: function() {
                if( success ) {
                    $container.html(`<div class="contact-form__success">${message}</div>`);
                    $('html, body').animate({ scrollTop: $form.offset().top - 100}, 500); 
                } else {
                    $container.append( `<div class="contact-form__error">${message}</div>` );
                }
                closeLoader( $loader );       
            },
        });
    }
    
    $(document).ready(function() {
        $(contactForm).on( 'submit', submitForm );
    });

})(jQuery);